export default __webpack_public_path__ + "static/media/icons-project-home.4e026d32.svg";